<template>
    <div class="ErrQuestion">
        <TopBar/>
        <div class="answer-content">
            <div class="route">
                <router-link
                        tag="span"
                        to="/MyWrongTopic"
                >
                    我的错题
                </router-link>
                <span></span>
                <span class="hover">错题解析</span>
            </div>
            <div class="answer-title">
                <h1>{{crs_name}}</h1>
                <div class="small-title">
                    <span>{{ques_name}}</span>
                    <span>共{{total_ques}}题</span>
                </div>
            </div>
            <div class="answer-list">
                <div class="list-warp"
                     v-for="(item,index) in answerSheetList"
                     :key="item.id"
                >
                    <div class="item-title">({{item.type_name}})</div>
                    <div class="item-subject">
                        <span>{{index+1}}.</span>
                        <span class="text-warp" v-html="item.content"></span>
                    </div>
                    <!--选择题 单选/多选-->
                    <ul class="choose"
                        v-if="item.type_id ==='radio' || item.type_id === 'checkbox'"
                    >
                        <li class="choose-item"
                            v-for="(i,subscript) in answerSheetList[index].options"
                            :key="subscript"
                        >
                            <div class="icon-warp"
                                 :class="classNameFun(item.right_answer,item.user_answer,i.option_num,item.type_id)">
                                <span class="item-title1">{{i.option_num}}</span>
                                <span class="iconfont icon-hook icon-right1"></span>
                                <span class="iconfont icon-fork icon-bad"></span>
                            </div>
                            <p v-html="i.title"></p>
                        </li>
                    </ul>
                    <!--判断题-->
                    <ul class="radio" v-if="item.type_id === 'boolean'">
                        <li>
                            <span class="iconfont icon-hook radio-choice"
                                  :style="rightColor(item.right_answer)"
                            >
                            </span><span class="span-bottom">正确</span>
                        </li>
                        <li>
                            <span class="iconfont icon-fork radio-choice"
                                  :style="badColor(item.right_answer)"
                            ></span>
                            <span>错误</span>
                        </li>
                    </ul>
                    <!--学生答案 正确答案 解析-->
                    <div class="answer-warp">
                        <span class="correct-answer">正确答案:{{item.right_answer}}</span>
                        <span class="student-answer" v-if="item.user_answer !== ''">您的答案:{{item.user_answer}}</span>
                        <span class="err-answer">错题次数:{{item.err_num}}</span>
                        <span class="student-answer" v-if="item.user_answer === ''">本题未作答</span>
                    </div>
                    <div class="tips">
                        <p>【解析】:</p>
                        <p v-html="item.resolution"></p>
                    </div>
                </div>
            </div>
        </div>
        <my-bottom/>
    </div>
</template>

<script>
    import TopBar from "../../components/common/TopBar"
    import myButton from "../../components/common/Button"
    import myBottom from "../../components/common/MyBottom"

    export default {
        name: "ErrQuestion",
        data() {
            return {
                //id
                ques_id: '',
                //已做题目
                ans_num: 0,
                //课程名
                crs_name: '',
                ques_name: '',
                //总条数
                total_ques: '',
                //小标题
                name: '',
                //题目list
                answerSheetList: [],
                //选项下标
                itemIndex: -1,
                className: '',
                //答对题目数量
                correct_data: '',
                //答错题目数量
                error_data: '',
                //未答题目数量
                no_ans_data: '',
                //已作答数量
                answeredCount: 0,
            }
        },
        components: {
            TopBar,
            myButton,
            myBottom
        },
        mounted() {
            this.getUpPageData();
            this.getSheet();
        },
        // computed: {
        //     classNameFun: function () {
        //         this.className = '';
        //         return this.className;
        //     }
        // },
        methods: {
            //获取页面信息list
            getSheet() {
                this.$get(this.BASEURL + '/errquestion/resolution',
                    {
                        ques_id: this.ques_id,
                    }
                ).then((res) => {
                    if (res.code === 200) {
                        this.answerSheetList = res.answer_list;
                        this.total_ques = res.total;
                    } else {
                        this.$message({
                            message: res.error,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            //获取上一页的数据
            getUpPageData() {
                this.ques_id = this.$route.query.id;
                this.crs_name = this.$route.query.crs_name;
                this.ques_name = this.$route.query.ques_name;
                this.name = this.$route.query.name;
                this.correct_data = this.$route.query.correct_data;
                this.error_data = this.$route.query.error_data;
                this.no_ans_data = this.$route.query.no_ans_data;
            },
            // 给每个选项添加class
            classNameFun(right_answer, user_answer, title, type) {
                if (type === 'radio') {
                    if (title === right_answer) {
                        return "icon-right";
                    } else if (title === user_answer) {
                        return "icon-user";
                    }
                    else {
                        return "icon-default";
                    }
                } else {
                    let tempArr1 = right_answer.split(",");
                    tempArr1.forEach((item) => {
                    });
                    for (let i = 0; i < tempArr1.length; i++) {
                        if (tempArr1[i] === title) {
                            return "icon-right";
                        }
                    }
                    if (user_answer === '') {
                        return "icon-default";
                    } else {
                        let tempArr2 = user_answer.split(",");
                        for (let i = 0; i < tempArr2.length; i++) {
                            if (tempArr2[i] === title) {
                                return "icon-user";
                            }
                        }
                    }
                }
            },
            // 给判断添加style
            rightColor(right_answer) {
                if (right_answer === '正确') {
                    return {
                        'color': '#fff',
                        'background-color': '#3D89FB',
                        'border-color': '#3D89FB'
                    }
                } else {
                    return {
                        'color': '#fff',
                        'background-color': '#F56C6C',
                        'border-color': '#F56C6C'
                    }
                }
            },
            badColor(right_answer) {
                if (right_answer === '错误') {
                    return {
                        'color': '#fff',
                        'background-color': '#3D89FB',
                        'border-color': '#3D89FB'
                    }
                } else {
                    return {
                        'color': '#fff',
                        'background-color': '#F56C6C',
                        'border-color': '#F56C6C'
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .icon-hook:before {
        content: "\2714";
    }

    .icon-fork:before {
        content: "\2716";
    }

    .ErrQuestion {
        position: relative;
        width: 100%;
        min-height: 100%;
        background-color: #F5F5F5;
        .answer-content {
            margin: 0 auto 50px;
            width: 1200px;
            min-width: 1200px;
            padding-top: 85px;
            box-sizing: border-box;
            .route {
                margin: 24px 0;
                span {
                    display: inline-block;
                    font-size: 14px;
                    line-height: 20px;
                    color: #666;
                    font-weight: 400;
                    cursor: pointer;
                }
                span:nth-child(2) {
                    position: relative;
                    padding: 0 16px;
                    &:before {
                        content: " ";
                        display: inline-block;
                        height: 7px;
                        width: 7px;
                        border-width: 1px 1px 0 0;
                        border-color: #999999;
                        border-style: solid;
                        -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
                        transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0) translateY(-50%);
                        position: absolute;
                        top: 50%;
                        right: 50%;
                        margin-top: -6px;
                    }
                }
                .hover {
                    cursor: default;
                    color: #3D89FB;
                }
            }
            .answer-title {
                height: 60px;
                padding: 37px 0;
                text-align: center;
                border-radius: 4px;
                background-color: #fff;
                h1 {
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 26px;
                    margin-bottom: 16px;
                    color: #333333;
                }
                .small-title {
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                    span {
                        display: inline-block;
                        line-height: 19px;
                    }
                    span:nth-child(2) {
                        padding-left: 16px;
                        color: #3D89FB;
                    }
                }
            }
            .answer-list {
                padding: 24px 22px 38px;
                margin-top: 24px;
                border-radius: 4px;
                background-color: #fff;
                .list-warp {
                    position: relative;
                    margin-top: 40px;
                    &:before {
                        content: "";
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        border-bottom: 1px solid #E4E4E4;
                        -webkit-transform: scaleY(.5);
                        -webkit-transform-origin: 0 0;
                    }
                    padding-bottom: 41px;
                    .item-title {
                        margin: 10px 0 0 10px;
                        font-size: 18px;
                        font-weight: 400;
                        line-height: 28px;
                        color: #333;
                    }
                    .item-subject {
                        display: flex;
                        margin: 10px 0 25px 10px;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 27px;
                        color: #333;
                    }
                    .choose {
                        .choose-item {
                            display: flex;
                            align-items: center;
                            padding: 10px 0 10px 10px;
                            margin-bottom: 4px;
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 18px;
                            color: #333;
                            cursor: pointer;
                            span {
                                position: relative;
                                display: inline-block;
                                width: 24px;
                                height: 24px;
                                margin-right: 15px;
                                font-size: 13px;
                                font-weight: 400;
                                line-height: 24px;
                                text-align: center;
                                border-radius: 24px;
                                color: #3D89FB;
                                border: 1px solid #3D89FB;
                            }

                            .icon-warp {
                                .item-title1 {
                                    display: none;
                                }
                                .icon-right1 {
                                    display: none;
                                    color: #fff;
                                    background-color: #3D89FB;
                                }
                                .icon-bad {
                                    display: none;
                                    color: #fff;
                                    border: 1px solid #FC6257;
                                    background-color: #FC6257;
                                }
                            }
                            .icon-default {
                                .item-title1 {
                                    display: block;
                                }
                            }
                            .icon-right {
                                .icon-right1 {
                                    display: block;
                                }
                            }
                            .icon-user {
                                .icon-bad {
                                    display: block;
                                }
                            }
                        }
                        .choose-item:last-of-type {
                            margin-bottom: 0;
                        }
                    }
                    .radio {
                        margin-left: 10px;
                        .radio-choice {
                            display: inline-block;
                            width: 26px;
                            height: 26px;
                            border: 1px solid #3D89FB;
                            line-height: 26px;
                            margin-right: 15px;
                            color: #3D89FB;
                            background-color: #fff;
                            text-align: center;
                            border-radius: 26px;
                            cursor: pointer;
                        }
                        .hover {
                            color: #fff;
                            background-color: #3D89FB;
                        }
                        span {
                            display: inline-block;
                            line-height: 26px;
                            font-size: 16px;
                        }
                        .span-bottom {
                            margin-bottom: 24px;
                        }
                    }
                    .answer-warp {
                        margin-left: 10px;
                        margin-top: 50px;
                        font-size: 18px;
                        font-weight: 400;
                        line-height: 27px;
                        color: #333;
                        span {
                            margin-right: 50px;
                        }
                    }
                    .tips {
                        margin-left: 10px;
                        font-size: 18px;
                        line-height: 27px;
                        margin-top: 30px;
                        color: #333;
                    }
                }
                .list-warp:first-of-type {
                    margin-top: 0;
                }
            }
            .submit {
                width: 100px;
                height: 40px;
                margin-top: 40px;
                line-height: 40px;
                font-size: 14px;
                text-align: center;
                border-radius: 4px;
                cursor: pointer;
                color: #fff;
                background-color: #3D89FB;
            }
        }
    }
</style>

